import { BehavioralVerb } from 'apps/web/types/labelled-collection.type';
import { createOptions } from 'apps/web/types/option';

export const STANDARD_RECEIVING_VERBS: BehavioralVerb[] = createOptions([
  'Ask',
  'Choose',
  'Describe',
  'Erect',
  'Follow',
  'Give',
  'Hold',
  'Locate',
  'Name',
  'Point to',
  'Reply',
  'Show interest',
  'Sit',
  'Study',
  'Use',
]);

export const STANDARD_RESPONDING_VERBS: BehavioralVerb[] = createOptions([
  'Accept responsibility',
  'Aid',
  'Answer',
  'Assist',
  'Comply',
  'Conform',
  'Discuss',
  'Enjoy',
  'Greet',
  'Help',
  'Label',
  'Obey',
  'Perform',
  'Practice',
  'Read',
  'Recite',
  'Report',
  'Tell',
  'Write',
]);

export const STANDARD_VALUING_VERBS: BehavioralVerb[] = createOptions([
  'Associate with',
  'Assume responsibility',
  'Be convinced',
  'Believe in',
  'Complete',
  'Demonstrate',
  'Describe',
  'Differentiate',
  'Explain',
  'Follow',
  'Form',
  'Have faith in',
  'Initiate',
  'Invite',
  'Join',
  'Justify',
  'Participate',
  'Propose',
  'Read',
  'Report',
  'Select',
  'Share',
  'Study',
  'Subscribe to',
  'Work',
]);

export const STANDARD_ORGANIZING_VERBS: BehavioralVerb[] = createOptions([
  'Adhere',
  'Alter',
  'Arrange',
  'Classify',
  'Combine',
  'Complete',
  'Establish',
  'Explain',
  'Form judgments',
  'Formulate',
  'Generalize',
  'Identify with',
  'Modify',
  'Order',
  'Organize',
  'Prepare',
  'Relate',
  'Synthesize',
  'Weigh alternatives',
]);

export const STANDARD_CHARACTERIZING_VERBS: BehavioralVerb[] = createOptions([
  'Act',
  'Change behavior',
  'Develop code of behavior',
  'Develop philosophy',
  'Discriminate',
  'Influence',
  'Judge problems/issues',
  'Modify',
  'Perform',
  'Practice',
  'Propose',
  'Qualify',
  'Question',
  'Revise',
  'Serve',
  'Show mature attitude',
  'Solve',
  'Verify',
]);
